import { Theme } from '@/theme';
import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  *,
  *::after,
  *::before {
    box-sizing: border-box;
  }

  html,
  body {
    font:
      ${Theme.font.style.normal} ${Theme.font.weight.regular}
      16px / 1.4 ${Theme.font.family.speedee}, ${Theme.font.family.roboto},
      'Helvetica', 'Arial', system-ui, -apple-system, sans-serif, monospace;

    background-color: ${Theme.color.white};
    -webkit-overflow-scrolling: touch;

    color: ${Theme.color.text};
    -webkit-user-select: none;
    overscroll-behavior: none;

    scroll-behavior: smooth;
    overflow: hidden auto;

    touch-action: none;
    user-select: none;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: ${Theme.font.weight.bold};
    color: ${Theme.color.text};
    font-family: ${Theme.font.family.speedeeCondensed};

    padding: 0px;
    margin: 0px;
  }

  a {
    text-decoration: underline;
    color: ${Theme.color.text};

    padding: 0px;
    margin: 0px;

    &:hover,
    &:focus,
    &:active,
    &:visited {
      outline: none;
    }
  }

  b,
  strong {
    font-style: normal;
    font-weight: ${Theme.font.weight.bold};
  }

  p,
  span {
    font-weight: ${Theme.font.weight.regular};
    line-height: ${Theme.rems(16)};
    color: ${Theme.color.text};

    padding: 0px;
    margin: 0px;
  }

  button {
    font-weight: ${Theme.font.weight.bold};
    color: ${Theme.color.text};

    cursor: pointer;
    outline: none;
    border: none;

    padding: 0px;
    margin: 0px;
  }

  img,
  svg,
  figure {
    vertical-align: top;
    max-width: 100%;
  }

  .grecaptcha-badge {
    pointer-events: none;
    visibility: hidden;
  }
`;
